<div class="bg-card rounded-3xl p-6 shadow-lg border border-gray-100 dark:border-foreground-tertiary  w-full max-w-4xl box-border">

  <div class="flex flex-col sm:flex-row sm:items-start justify-between mb-8">
      <div>
          <h2 class="text-[#101828] text-xl font-bold mb-1 dark:text-white tracking-tight">BMI History</h2>
          <p class="text-sm text-muted-color font-medium">Review your BMI records from assessments.</p>
      </div>

      <div class="mt-4 sm:mt-0">
          <p-dropdown
              [options]="filterOptions"
              [(ngModel)]="selectedFilter"
              (onChange)="onFilterChange()"
              optionLabel="label"
              optionValue="value"
              styleClass="border-1 dark: bg-card text-foreground shadow-none text-sm   dark:border-foreground-tertiary   font-medium rounded-full px-2 py-0.5  focus:shadow-none min-w-[130px]"
              dropdownIcon="pi pi-chevron-down text-xs">
          </p-dropdown>
      </div>
  </div>

  <div class="relative w-full h-[240px] mb-8">
      <div *ngIf="loading" class="absolute inset-0 flex justify-center items-center bg-white/50 z-10 dark:bg-card/50">
          <i class="pi pi-spin pi-spinner text-2xl text-[#F5A623]"></i>
      </div>

      <patient-custom-graph
          [labels]="graphDates"
          [dataValues]="graphValues"
          lineColor="#EF4444"
          tooltipSuffix="Current BMI"
          [targetLineValue]="19.5"
          targetLineLabel="Healthy Range">
      </patient-custom-graph>
  </div>

  <div class="flex items-start gap-4 pt-4 border-t-0 mt-2">
      <div class="mt-0.5 w-[26px] h-[26px] flex justify-center items-center flex-shrink-0">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" class="text-[#facc15]" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg>
      </div>

      <div>
          <h4 class="text-[15px] font-bold text-gray-900 dark:text-gray-100 tracking-tight leading-snug">
              BMI has
              <span *ngIf="latestProgress === 0">remained stable</span>
              <span *ngIf="latestProgress !== 0">{{ !isPositive ? 'improved' : 'worsened' }} by </span>
              <span *ngIf="latestProgress !== 0" [ngClass]="isPositive ? 'text-[#EF4444]' : 'text-[#10B981]'">
                  {{ isPositive ? '+' : '-' }}{{ latestProgress | number:'1.1-2' }} points
              </span>
              <span *ngIf="latestProgress !== 0"> since last assessment.</span>
          </h4>
          <p class="text-[13px] text-gray-600 mt-1.5 leading-relaxed tracking-wide font-medium dark:text-gray-400">
              {{ getHintText() }}
          </p>
      </div>
  </div>

</div>
